import { useState, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { getTrialStatus } from '../EnquiryList/enquiryUtils';

export const useEnquiryHistory = () => {
    const { state } = useLocation();
    const [report, setReport] = useState(state?.data || null);

    const refershReport = (newFollowup) => {
        if (!newFollowup) return;
        setReport((prev) => {
            if (!prev) return prev;
            const updatedFollowups = (prev.followups || []).map((f) => ({
                ...f,
                status: 'postpond'
            }));
            const { enquiry: _, ...cleanFollowup } = newFollowup;
            return {
                ...prev,
                followups: [...updatedFollowups, cleanFollowup]
            };
        });
    };

    const trialStatus = useMemo(() => {
        if (!report) return null;
        return getTrialStatus(report.tryal_date, report.tryal_period);
    }, [report]);

    const latestFollowup = useMemo(() => {
        if (!report?.followups || report.followups.length === 0) return null;
        return report.followups[report.followups.length - 1];
    }, [report]);

    const trialEndDate = useMemo(() => {
        if (!report?.tryal_date) return null;
        const end = new Date(report.tryal_date);
        end.setDate(end.getDate() + (report.tryal_period || 0));
        return end;
    }, [report]);

    return {
        report,
        setReport,
        refershReport,
        trialStatus,
        latestFollowup,
        trialEndDate
    };
};

export default useEnquiryHistory;
